export default "__VITE_ASSET__2103319d__"